import { useMainMachine } from '../../../utils/useMainMachine';
import { Button } from '../basic-ui/Button';
import { ACTIONS } from '../../../state';
import { BUTTON_TYPES, GENERATING } from '../../constants';

import RedoIcon from '@crazyegginc/hatch/dist/images/icon-redo.svg?react';

export function UndoRedo() {
  const { machine, useSelector } = useMainMachine();
  const canUndo = useSelector(({ context }) => context.canUndo);
  const canRedo = useSelector(({ context }) => context.canRedo);
  const generating = useSelector((state) => state.hasTag(GENERATING));

  return (
    <>
      <Button
        disabled={!canUndo || generating}
        onClick={() => machine.send({ type: ACTIONS.UNDO })}
        variant={BUTTON_TYPES.SECONDARY}
        className="mr-1.25"
      >
        <RedoIcon className="w-4 h-4 fill-current scale-x-[-1]" aria-label="undo" />
      </Button>
      <Button
        disabled={!canRedo || generating}
        onClick={() => machine.send({ type: ACTIONS.REDO })}
        variant={BUTTON_TYPES.SECONDARY}
      >
        <RedoIcon className="w-4 h-4 fill-current" aria-label="redo" />
      </Button>
    </>
  );
}
